<template>
  <div class="result-card result-card-skeleton">
    <div class="result-card-skeleton-details">
      <div class="result-card-skeleton-title shimmer"></div>
      <div class="result-card-skeleton-description shimmer"></div>
    </div>
    <div class="result-card-image shimmer">
      <div class="media-scaled media-16-by-9"></div>
    </div>
  </div>
</template>
